import type {FetchIdentificationInfoResponse} from '../../http';
import {fetchIdentificationInfo} from '../../http';
import {useQuery, type UseQueryOptions} from 'react-query';

export function useFetchIdentificationInfo(options?: UseQueryOptions<FetchIdentificationInfoResponse>) {
	return useQuery<FetchIdentificationInfoResponse>({
		queryKey: ['identification', 'info'],
		queryFn: async ({signal}) => {
			const {data} = await fetchIdentificationInfo(signal);

			return data;
		},
		...options,
	});
}
